var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.51 1.15482L11.3876 1.2772L11.51 1.15482C10.3716 0.0164605 8.45255 0.327885 7.73254 1.76781L7.73253 1.76782L5.79703 5.63889L5.95184 5.71629L5.79703 5.6389C5.74758 5.7378 5.66136 5.81341 5.55682 5.84952L2.24573 6.99333L2.24573 6.99333C1.43133 7.27469 1.19251 8.31148 1.80177 8.92076L1.92415 8.79838L1.80177 8.92076L4.14664 11.2656L0.740961 14.6713L0.690273 14.722L0.690268 14.7937L0.690204 15.6367L0.690191 15.8098H0.863281H1.70629H1.77798L1.82868 15.7591L5.23436 12.3533L7.57922 14.6983L7.57923 14.6983C8.18851 15.3075 9.22529 15.0687 9.50665 14.2543L10.6505 10.9432L10.6505 10.9432C10.6866 10.8387 10.7622 10.7524 10.8611 10.703C10.8611 10.703 10.8611 10.7029 10.8611 10.7029L14.7322 8.76745L14.6548 8.61265L14.7322 8.76745C16.1721 8.04744 16.4836 6.1284 15.3452 4.99004L11.51 1.15482ZM9.10844 2.45574L9.10845 2.45573C9.35881 1.95493 10.0263 1.8466 10.4222 2.24253L10.5446 2.12015L10.4222 2.24253L14.2575 6.07776C14.6534 6.47369 14.5451 7.14117 14.0443 7.39154L14.0443 7.39154L10.1732 9.32713L10.1732 9.32713C9.71459 9.55646 9.364 9.9562 9.19656 10.4409L8.24674 13.1903L3.30971 8.25325L6.05909 7.30351L6.0591 7.30351C6.54378 7.13606 6.9436 6.78546 7.17294 6.32682L7.17294 6.32681L9.10844 2.45574Z",
    fill: "#97A0AF",
    stroke: "#97A0AF",
    strokeWidth: 0.346154
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinChat);
export default __webpack_public_path__ + "static/media/pin_chat.69ceb2701857c2303a72eced962bc9a6.svg";
export { ForwardRef as ReactComponent };